import React, { useEffect, useState } from 'react'
import { FormWrapper, Label, Select, Button, Input } from './shared_form_styles';
import { useDispatch, useSelector } from "react-redux";
import { setStudents } from '../actions/studentActions';



export const GetAttendanceCode = () => {
    const subjectInstanceSelected = useSelector((state) =>
        state.selection.selectedSubjectInstance ? state.selection.selectedSubjectInstance : null
    );
    const attendanceModified = useSelector((state) => state.loading.attendanceModified);
    const [loadingModifications, setLoadingModifications] = useState(null);
//     const code = useSelector((state) =>
//     state.selection.selectedSubjectInstance?.code ? state.selection.selectedSubjectInstance?.code : null
// );
const dispatch = useDispatch();
useEffect(() => {
    if (!attendanceModified) {
      setLoadingModifications(false);
    }
    if (attendanceModified) {
        setLoadingModifications(true);
        dispatch(setStudents());
      }
  }, [attendanceModified]);
    const [code, setCode] = useState("");

    useEffect(() => {
        if(subjectInstanceSelected){
            setCode(subjectInstanceSelected.code);
        }
  
    },[subjectInstanceSelected])
    return (
        <FormWrapper>
            <Label>
                Codigo:
            </Label>
            <Label>
               {code}
            </Label>

        </FormWrapper>
    );
};


export default GetAttendanceCode;
